(function ($) {

    var width = 900,
        height = 490;

    var projection = d3.geo.robinson()
        .scale(180)
        .translate([((width / 2)-50), ((height / 2)+30)]);

    var path = d3.geo.path()
        .projection(projection);

    var graticule = d3.geo.graticule();

    var centered = null,
        g = null,
        items = null,
        postLookup = {},
        tracker = null;


    function clicked(d) {
        if ($(".node-type-article").size() >= 1) {
            d3.event.stopPropagation();
            window.location.href = '//www.publicintegrity.org/ambassadors#country?slug=' + sluggify(d.properties.name);
            return true;
        }

        hideTooltip();

        var x, y, k;

        if (typeof d.properties != "undefined" && d.properties.name.toUpperCase() in postLookup && centered !== d) {

            if (typeof _gaq !== 'undefined' && typeof _gaq === 'object') {
                 _gaq.push(['_trackEvent', 'Interactive', 'Click', 'Ambundlers: ' + d.properties.name ]);
            }

            $.scrollTo(".node-freeform.full .intro",200,{axis:'y'});

            setFilter(postLookup[d.properties.name.toUpperCase()].post);
            var centroid = path.centroid(d);
            x = centroid[0];
            y = centroid[1];
            k = 2.5;
            centered = d;

            tracker.find(".map")
                .addClass("zoomedIn");

        } else {
            setFilter("");
            showBundlers();

            x = width / 2;
            y = height / 2;
            k = 1;
            centered = null;

            tracker.find(".map")
                .removeClass("zoomedIn");
        }

        g.selectAll("path")
            .classed("active", centered && function(d) { return d === centered; });

        g.transition()
            .duration(750)
            .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")" +
                "scale(" + k + ")translate(" + -x + "," + -y + ")")
            .style("stroke-width", 1.5 / k + "px");
    }

    function showTooltip (d) {
        if (d.properties.name.toUpperCase() in postLookup) {
            var svg = d3.select(".politicalAmbassadorTracker .map svg");

            var coords = d3.mouse(svg.node());

            var tooltip = svg.select(".tooltip")
                .style("display","block")
                .attr("transform","translate(" + d3.round(coords[0]+30) + " " + d3.round(coords[1]-20) + ")");

            var headerBox = tooltip.select(".tooltipHeader")
                        .text(postLookup[d.properties.name.toUpperCase()].name)
                        .node().getBBox();

            var labelBox = tooltip.select(".tooltipLabel")
                        .text(postLookup[d.properties.name.toUpperCase()].post)
                        .node().getBBox();

            tooltip.select("rect").attr("width",d3.max([headerBox.width,labelBox.width])+20);
        }
    }

    function hideTooltip () {
        d3.select(".politicalAmbassadorTracker .tooltip")
                .style("display","none");
    }

    function sluggify(name) {
        return name.replace(' ','-').replace('(','').replace(')','').toLowerCase();
    }

    function findCountry(slug) {
        var selectedCountry = null;
        d3.selectAll('.politicalAmbassadorTracker .map .country')
                .each(function (country) {
                    if (sluggify(country.properties.name) == slug) {
                        selectedCountry = country;
                    }
                });

        return selectedCountry;
    }

    function hashHit(hash) {
        if (hash.base == 'country' && hash.parameters &&
                'slug' in hash.parameters) {
            var c = findCountry(hash.parameters.slug);
            if (c !== null) {
                clicked(c);
            }
        }
    }

    function drawMap (err,ambassadors,world) {
        var list = ambassadors.list;

        postLookup = {};
        list.forEach(function (d,i) {
            if (d.status === 'nominated' || d.status === 'confirmed') {
                var posts = list[i].post.split(/( and|,) /g);

                for (var i2 in posts) {
                    if (posts.hasOwnProperty(i2)) {
                        var post = posts[i2];
                        if (post) {
                            postLookup[post.trim().toUpperCase()] = d;
                        }
                    }
                }
            }
        });

        var countries = topojson.feature(world, world.objects.world).features;

        var svg = null;

        try {

            svg = d3.select(".politicalAmbassadorTracker .map")
                        .append("svg")
                            .attr("width", "100%")
                            .attr("height", "100%")
                            .attr("viewBox","0 0 " + width + " " + height);

        }
        catch (e) {
            return;
        }

        tracker.find(".map").css("background-image","none");

        g = svg.append("g");

        g.append("path")
            .datum({type: "Sphere"})
            .attr("class", "sphere")
            .attr("d", path);

        g.append("path")
            .datum(graticule)
            .attr("class", "graticule")
            .attr("d", path);

        g.selectAll(".country")
          .data(countries)
          .enter()
            .append("path")
              .attr("d", path )
              .on("click",clicked)
              .on("mouseover",showTooltip)
              .on("mouseout",hideTooltip)
              .attr("class", function (d) {
                var r = "country";
                if (d.properties.name.toUpperCase() in postLookup) {
                    r += " " + postLookup[d.properties.name.toUpperCase()].type +
                                " " + postLookup[d.properties.name.toUpperCase()].status;
                }
                else {
                    r += " irrelevant";
                }
                return r;
              });

        var tooltip = svg.append("g")
                            .attr("class","tooltip")
                            .style("display","none");

        tooltip.append("rect")
                    .attr("class","tooltipBack")
                        .attr("width",200)
                        .attr("height",50);

        tooltip
            .append("text")
                .attr("class","tooltipHeader")
                .attr("x",10)
                .attr("y",20);

        tooltip
            .append("text")
                .attr("class","tooltipLabel")
                .attr("x",10)
                .attr("y",40);

        initHashNav(hashHit);

    }


    function setFilter(val) {
        var box = tracker.find(".filter input");
        if (val === "") {
            box.val("Find ambassador or post")
                .css("color","rgb(200,200,200)");
        }
        else {
            box.val(val);
            $(".filter input").css("color","black");
        }
        filterList();
    }

    function showOnly(type) {
        setFilter("");
        tracker.find(".list .noResults").remove();

        tracker.find(".box:not(." + type + ")").removeClass("active");
        tracker.find(".box." + type).addClass("active");
        tracker.find(".item:not(." + type + ")").addClass("hidden");
        tracker.find(".item." + type).removeClass("hidden");
    }

    function showBundlers() {
        showOnly("bundler");

        tracker.find(".item.bundler").addClass("noDetails");
        tracker.find(".item.bundler").first().removeClass("noDetails");
    }

    function showOthers() {
        showOnly("other");
    }

    function showCareer() {
        showOnly("career");
    }

    function filterList() {
        tracker.find(".box").removeClass("active");


        var name = $(".filter input").val().toLowerCase();

        tracker.find(".item").each(function (i) {
            that = $(this);
            if (that.find("h4").text().toLowerCase().indexOf(name) === -1 &&
                    that.find(".post").text().toLowerCase().indexOf(name) === -1) {
                that.addClass("hidden");
            }
            else {
                that.removeClass("hidden");
            }
        });

        if (tracker.find(".item:not(.hidden)").length === 0) {
            if (tracker.find(".list .noResults").length === 0) {
                tracker.find(".list")
                    .append('<div class="noResults"><h2>No ambassador found.</h2></div>');
                }
        }
        else {
            tracker.find(".list .noResults").remove();
        }
    }

    function attachToTabs() {
        tracker.find(".box.bundler").on("click",showBundlers);
        tracker.find(".box.other").on("click",showOthers);
        tracker.find(".box.career").on("click",showCareer);
    }

    function setupFilter() {
        defaultText = "Find ambassador or post";

        tracker.find(".filter input")
            .on("keyup",filterList)
            .on("focus",function () {
                var box = $(this);
                if (box.val() === defaultText) {
                    box.val("")
                        .css("color","black");
                }
            })
            .on("blur",function () {
                var box = $(this);
                if (box.val() === "") {
                    box.val(defaultText)
                        .css("color","rgb(200,200,200)");

                    showBundlers();
                }
            });
    }

    function fetchData() {
        var prefix = "";
        if (document.location.hostname == "www.publicintegrity.org") {
            prefix = "//iw-files.s3.amazonaws.com/apps/2013/07/ambassadortracker/";
        }

        queue()
            .defer(d3.json,prefix + "data/ambassadors.json")
            .defer(d3.json,prefix + "data/world.json")
            .await(drawMap);
    }

    function attachZoomOut() {
        tracker.find(".zoomOut")
                .on("click",clicked);
    }

    function init() {        
        $(".node-type-article .politicalAmbassadorTracker").on("click",function () {
            window.location.href = '//www.publicintegrity.org/ambassadors';
        });

        tracker = $(".politicalAmbassadorTracker");

        if (tracker.length !== 1) {
            return;
        }

        if (typeof pym !== 'undefined') {
            var pymChild = pym.Child({
                polling: 200
            });
        }
        
        setupFilter();
        attachToTabs();
        fetchData();
        attachZoomOut();

        $('.tooltip').tooltipster({
            contentAsHTML: true,
            theme: 'tooltipster-light'
        });

    }

    init();

})(jQuery);
